var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAiSquareBold = function SvgAiSquareBold(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.904 12.5v5a1.5 1.5 0 1 1-3 0v-5a1.5 1.5 0 1 1 3 0Zm3.5-2.5a1.5 1.5 0 0 0-1.5 1.5v7c0 1.378-1.122 2.5-2.5 2.5h-13a2.503 2.503 0 0 1-2.5-2.5v-13c0-1.378 1.122-2.5 2.5-2.5h7a1.5 1.5 0 1 0 0-3h-7a5.506 5.506 0 0 0-5.5 5.5v13c0 3.033 2.467 5.5 5.5 5.5h13c3.033 0 5.5-2.467 5.5-5.5v-7a1.5 1.5 0 0 0-1.5-1.5ZM12.306 6.827l2.554 10.312a1.5 1.5 0 0 1-2.912.72l-.213-.86H8.073l-.213.86a1.5 1.5 0 1 1-2.912-.72L7.484 6.892c.335-1.139 1.301-1.86 2.42-1.86s2.084.721 2.402 1.794ZM11.43 14l-1.375-5.554c-.039-.159-.266-.159-.305 0L8.376 14h3.053Zm4.162-8.515 1.978.833.789 1.974a1.126 1.126 0 0 0 2.09 0l.785-1.963 1.963-.785a1.126 1.126 0 0 0 0-2.09l-1.963-.785-.785-1.963a1.126 1.126 0 0 0-2.09.002l-.78 1.951-1.948.738a1.124 1.124 0 0 0-.039 2.088Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAiSquareBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ai-square-bold.9154b748.svg";
export { ForwardRef as ReactComponent };